import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';
import i18n from '../../../../../translations/strings';
import { MapStyled } from './map-leaflet.styled';
import { useEffect, useRef } from 'react';

export interface MapProps {
  handleRefMap: (ref: any) => void;
}

const MapComponent = (props: MapProps) => {
  const mapRef = useRef(null);

  useEffect(() => {
    props.handleRefMap(mapRef);
  }, [mapRef]);
  const customIcon = new Icon({
    iconUrl: '/assets/map_marker.svg',
    iconSize: [38, 38],
  });

  const openGoogleMaps = () => {
    const url = `https://www.google.com/maps/place/Allianz+Sassari+Sandalion/@40.7199634,8.5823513,19.04z/data=!4m6!3m5!1s0x12dc61551558218d:0xa6a7d2eff9dae891!8m2!3d40.7199107!4d8.5825205!16s%2Fg%2F1q69_v0w3?entry=ttu`;
    window.open(url, '_blank');
  };

  return (
    <MapStyled.Container ref={mapRef}>
      <MapContainer
        center={[40.71993001122941, 8.582587385926795]}
        zoom={20}
        scrollWheelZoom={false}
        style={{ height: '260px', width: '100%' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker
          position={[40.71993001122941, 8.582587385926795]}
          icon={customIcon}
        >
          <Popup>
            <MapStyled.TitlePopUp
              style={{ fontWeight: 'bold', fontSize: '16px' }}
            >
              {i18n.t('landing.allianzAddress')}
            </MapStyled.TitlePopUp>

            <MapStyled.SubtitlePopUp onClick={openGoogleMaps}>
              {i18n.t('landing.viewOnMaps')}
            </MapStyled.SubtitlePopUp>
          </Popup>
        </Marker>
      </MapContainer>
    </MapStyled.Container>
  );
};

export default MapComponent;
